import React from 'react';
import { Row, Col } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressCard } from '@fortawesome/free-solid-svg-icons'

export default function ProcessButton(props) {
  
  let whiteColor = '#fff';
  let textValue = props.text;
  let bgColor = props.bgColor;
  let fontSize = 20, textSize = 12;
  let fontIcon = faAddressCard;

  return (
    <Row onClick={()=>{props.onClick()}} style={{ width: 176, background: bgColor, height: 40, cursor: 'pointer' }}>
        <Col style={{ display: 'flex', alignItems:'center', justifyContent: 'center', backgroundColor: whiteColor }} span={6}>
            <FontAwesomeIcon icon={fontIcon} style={{ color: bgColor, fontSize: fontSize }} />
        </Col>
        <Col style={{ display: 'flex', justifyContent: 'center', alignItems:'center', backgroundColor: bgColor,
        fontSize: textSize, lineHeight: 1.1, fontFamily: 'OpenSans-SemiBold', color: whiteColor }} span={18}>
            {textValue}
        </Col>
    </Row>
  );
}
